import content from './content/contact-us.json';

export const contactUsMock = {
  name: 'contact-us',
  layoutType: 1,
  areasList: [
    {
      id: 'contact-us-main',
      componentName: 'Comp:ContactUsPage',
      content: JSON.stringify(content)
    }
  ]
};
